import BackendError from './BackendError';

// The backend node server itself is not available
export default class BackendServerUncontactableError extends BackendError {}
